/*jshint esnext: true */
/*global jQuery, dis, svg4everybody */

/* DIS/PLAY Script
 Author's name: ...
 Modified by:
 Client name: ...
 Date of creation: ...
 */

(function ($, dis) {
	"use strict";


	function init() {


		// Set up singletons for handling various UI-elements
		var headerHandler = new dis.ui.Header({container: $("#headerWrapper") }),
			/*jshint unused:true */
			miscellaneousHandler = new dis.ui.Miscellaneous()
			/*jshint unused:false */
			;


		// Let's very autocomplete!
		$("[data-autocomplete]").each(function () {
			/*jshint ignore:start */
			var autocomplete = new dis.Autocomplete({container: this});
			/*jshint ignore:end */
		});



		// Ditto for autotruncate-elements
		$("[data-autotruncate]").each(function () {
			/*jshint ignore:start */
			var truncator = new dis.ui.Autotruncate({container: this});
			/*jshint ignore:end */
		});


		$(".bg-imagehandler--parallax").each(function () {
			/*jshint ignore:start */
			var parallax0r = new dis.ui.ParallaxImage({container: this});
			/*jshint ignore:end */
		});


		$(".agenda__list").each(function () {
			/*jshint ignore:start */
			var AgendaList = new dis.ui.AgendaList({container: this});
			/*jshint ignore:end */
		});

		// Allow animation on elements requesting it, after a short timeout. This is to avoid
		// flashes of animation once the stylesheet loads.
		window.setTimeout(function () {
			$(".defer-animation").removeClass("defer-animation").addClass("allow-animation");
		}, 500);


		// Load SVGs, in case the browser can't handle it itself.
		svg4everybody();


		// Fire up the image handler.
		window.disImageHandler = new dis.ImageHandler();


		if (document.documentMode) {
			// Load placeholders, because... well, because reasons.
			if (document.documentMode <= 9) {
				$("[placeholder]").placeholder();
			}

			if (document.documentMode === 11) {
				$("html").addClass("ie11");

				headerHandler.fixMenuItemsInIE11();
			}
		}

		$(document).on('keyup', function(e) {
			if (e.keyCode === 9) {
				console.log('activeElement', document.activeElement)
			}
		})

	}


	// Initialize the main script(s) once the DOM is ready. Not only does this mean that all your DOM-references will
	// work, but more importantly: Gulp is compiling all your scripts into one big file, but the closures are run as soon
	// as they're available. Meaning: if your "main" closure is run BEFORE your "module"-closure, it might try to instantiate
	// your modules before the browser actually knows them. Using jQuery's ready-function alleviates this problem.
	dis.BaseModule.prototype.onReady(init);


}(jQuery, dis));

